import { VideoIcon } from "@shapeable/icons";
import React, { useContext } from "react";
export var VideoIconContext = React.createContext(VideoIcon);
export var VideoIconProvider = VideoIconContext.Provider;
export var useVideoIcon = function () {
  return useContext(VideoIconContext);
};